/**
 * Shared test ID constants for `data-testid` attributes.
 * Add constants here when a test ID is reused across multiple test files.
 * See docs/DATA_TEST_ID_CONVENTION.md for naming conventions.
 */

// ─── Shared Patterns ────────────────────────────────────────────────────────
// Non-unique IDs for repeating UI patterns. Scope lookups via parent container
// to avoid ambiguity (e.g. table.getByTestId('table-pagination-next')).

// ─── Table ────────────────────────────────────────────────────────────────────

export const TABLE = {
  pagination: {
    next: 'table-pagination-next',
    prev: 'table-pagination-prev',
    first: 'table-pagination-button-first',
    last: 'table-pagination-button-last',
    rowsPerPage: 'table-pagination-rows-per-page',
    pageInfo: 'table-pagination-page-info',
  },
} as const;

// ─── Dialog ────────────────────────────────────────────────────────────────────

export const DIALOG = {
  closeButton: 'dialog-close-button',
} as const;

// ─── Navigation ─────────────────────────────────────────────────────────────────

export const NAV = {
  logo: 'nav-logo',
  userMenu: 'nav-user-menu',
  userMenuName: 'nav-user-menu-name',
  userMenuEmail: 'nav-user-menu-email',
  userMenuProfile: 'nav-user-menu-profile',
  userMenuPrivacyPolicy: 'nav-user-menu-privacy-policy',
  userMenuLogout: 'nav-user-menu-logout',
  mobileMenuButton: 'nav-mobile-menu-button',
  mobileMenuClose: 'nav-mobile-menu-close',
  sidebarCollapseToggle: 'nav-sidebar-collapse-toggle',
} as const;
